import * as actionTypes from './actionTypes';

const unionSet = (setA, setB) => {
  const _union = new Set(setA);
  for (const elem of setB) {
    _union.add(elem);
  }
  return _union;
};

const convertDataToSet = (payload) =>
  Array.isArray(payload)
    ? new Set(payload)
    : payload instanceof Set
    ? payload
    : new Set();

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case actionTypes.setCheckedAndHalfCheckedKeys: {
      const { checkedKeys, halfCheckedKeys } = payload;

      return {
        ...state,
        checkedKeys: convertDataToSet(checkedKeys),
        halfCheckedKeys: convertDataToSet(halfCheckedKeys),
      };
    }

    case actionTypes.setCheckedKeys: {
      return {
        ...state,
        checkedKeys: convertDataToSet(payload),
      };
    }

    case actionTypes.setHalfCheckedKeys: {
      return {
        ...state,
        halfCheckedKeys: convertDataToSet(payload),
      };
    }

    case actionTypes.toggleExpandAction: {
      const {
        key,
        addKeyToLoadedKeys,
        addKeyToExpandedKeys,
        addedCheckedKeys,
      } = payload;

      const loadedKeys = new Set(state.loadedKeys);
      const expandedKeys = new Set(state.expandedKeys);
      const checkedKeys = unionSet(state.checkedKeys, addedCheckedKeys);

      if (addKeyToLoadedKeys) {
        loadedKeys.add(key);
      }

      addKeyToExpandedKeys ? expandedKeys.add(key) : expandedKeys.delete(key);

      return {
        ...state,
        loadedKeys,
        expandedKeys,
        checkedKeys,
      };
    }
  }
};
